import React from 'react';
import {
  FaBuilding,
  FaPlay,
  FaCamera,
  FaVideo,
  FaComments,
  FaUsers,
  FaCogs,
  FaLightbulb,
  FaClipboardList,
  FaUserCheck,
  FaBriefcase,
  FaCloudDownloadAlt
} from 'react-icons/fa';

// --- UPDATED: featureData now uses bgColor for a clean, two-tone icon system ---
// All SVG blob imports have been removed.
const featureData = [
  // { iconColor: (icon), bgColor: (light circle background) }
  { bgColor: '#EAF2FB', iconColor: '#4A90E2', Icon: FaBuilding, title: 'Offline Trainings', desc: 'Learn under our guidance' },
  { bgColor: '#E8F8F1', iconColor: '#3CB371', Icon: FaPlay, title: 'Live online classes', desc: 'Learn from home' },
  { bgColor: '#F4F2F9', iconColor: '#8B7AB8', Icon: FaCamera, title: 'Daily class recordings', desc: 'Revise concepts' },
  { bgColor: '#FDF3E9', iconColor: '#975224', Icon: FaVideo, title: 'Pre-recorded videos', desc: 'Learn anytime, anywhere' },
  { bgColor: '#E8EDFB', iconColor: '#3568d4', Icon: FaComments, title: 'Group discussions', desc: 'Develop soft skills' },
  { bgColor: '#EAF8F7', iconColor: '#4DB8AC', Icon: FaUsers, title: '5k+ Students community', desc: 'Learn together' },
  { bgColor: '#F5F2FC', iconColor: '#9978db', Icon: FaCogs, title: 'Teams & group tasks', desc: 'Learn real skills for industry needs' },
  { bgColor: '#FBF0E3', iconColor: '#ae6506', Icon: FaLightbulb, title: 'Live course revision', desc: 'Master skills better' },
  { bgColor: '#FDF1EA', iconColor: '#df7630', Icon: FaClipboardList, title: 'Assignments & projects', desc: 'Make you industry ready' },
  { bgColor: '#F0F5FA', iconColor: '#6B9BD6', Icon: FaUserCheck, title: 'Individual feedback', desc: 'Improvise your growth' },
  { bgColor: '#EBF8F4', iconColor: '#5CB88F', Icon: FaBriefcase, title: 'Placement trainings', desc: 'Easily land your dream job' },
  { bgColor: '#EEF6FD', iconColor: '#5BA8E8', Icon: FaCloudDownloadAlt, title: 'Downloadable content', desc: 'Learn anywhere, anytime' },
];

/**
 * Reusable component for a single feature card.
 * - Removed 'svg' prop
 * - Added 'bgColor' prop
 * - Icon container is now a clean, colored circle.
 */
const FeatureCard = ({ iconColor, bgColor, Icon, title, desc }) => {
  return (
    <div className="col-6 col-sm-6 col-md-4 col-lg-3">
      <div
        className="card h-100 border-0 shadow-sm text-center"
        style={{
          borderRadius: '20px',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          cursor: 'pointer'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-8px)';
          e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.07)';
        }}
      >
        {/* --- REFINED: Card body with balanced padding --- */}
        <div className="card-body p-4">
          
          {/* --- REFINED: Icon container is now a simple, aesthetic circle --- */}
          <div
            className="d-inline-flex align-items-center justify-content-center mb-3"
            style={{
              width: '72px',
              height: '72px',
              borderRadius: '50%',
              backgroundColor: bgColor, // Use light background color
              color: iconColor,       // Use dark icon color
            }}
          >
            <Icon size={32} /> {/* Refined icon size */}
          </div>
          
          <h5 className="card-title fw-bold mb-1" style={{ color: '#2C3E50', fontSize: '1.1rem' }}>
            {title}
          </h5>
          <p className="card-text text-muted" style={{ fontSize: '0.9rem' }}>
            {desc}
          </p>
        </div>
      </div>
    </div>
  );
};


function HackingBenefits() {
  return (
    // --- REFINED: Cleaner background color ---
    <div style={{ backgroundColor: '#F4F7FC', minHeight: '100vh', padding: '60px 0px' }}>
      <div className="container">
        
        {/* --- REFINED: Title Section --- */}
        <div className="text-center mb-5">
          <h1 className="display-4 fw-bolder mb-3" style={{ color: '#2C3E50' }}>
            <span>
              Unlock Your Potential
            </span>
            <br />
            <span >
              For Exceptional Results
            </span>
          </h1>
        </div>

        {/* Features Grid */}
        <div className="row g-4">
          {/* Dynamically create all feature cards */}
          {featureData.map((feature, index) => (
            <FeatureCard 
              key={index}
              bgColor={feature.bgColor} // Pass new prop
              iconColor={feature.iconColor}
              Icon={feature.Icon}
              title={feature.title}
              desc={feature.desc}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default HackingBenefits;